"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CustomerSelection = require("./CustomerSelection");
Object.keys(_CustomerSelection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CustomerSelection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CustomerSelection[key];
    }
  });
});
